import {FormBaseComponent} from '@utils-lib';
import {HandelsregistereintragNotarVertragAngaben} from '@nachdigal';
import {Component} from '@angular/core';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {FormBuilder} from '@angular/forms';

@Component({
    selector: 'common-ui-notar-angaben',
    templateUrl: './notar-angaben.component.html'
})
export class NotarAngabenComponent extends FormBaseComponent<HandelsregistereintragNotarVertragAngaben> {

    constructor(private readonly formBuilder: FormBuilder, protected readonly messageService: DatevMessageService) {
        super(messageService);
    }

    public clearNotar($event: unknown): void {
        if (!$event) {
            this.data.notarPerson = null;
            this.data.notarInlandsadresse = null;
            this.data.notarAuslandsadresse = null;
            this.data.notarPostfachadresse = null;
        }
    }

    protected createForm(): void {
        this.form = this.formBuilder.group({
            hatNotarAngaben: [{value: this.data.hatNotarAngaben, disabled: this.readonly}, []]
        });
    }

}
